import * as React from 'react';
import { StageProducer, createStages } from '../Models/Report';
import Loading from './Loading';
import Box from './Box';
import PieChart from './PieChart';
import { getColorStatus } from '../Models/Colors';
import SummaryTitleItem from './SummaryTitleItem';
import SummaryItem from './SummaryItem';
import './CardSummaryStage.scss';

export interface ICardSummaryStage {
	producersStage: StageProducer[];
}

const createData = (producersStage: StageProducer[]) => {
	const stages = createStages().map(s => {
		const producers = producersStage;
		let total = 0;
		for (let i = 0; i < producers.length; i += 1) {
			const stage = producers[i].stages.find(sp => sp.report === s.report);
			if (stage) {
				total += stage.data.total;
			}
		}
		s.data.total = total;
		return s;
	});
	return stages;
}

const CardSummaryStage =  (props: ICardSummaryStage) => {
	const isReady = props.producersStage.find(p => !StageProducer.isReady(p)) == null;
	const data = createData(props.producersStage);
	const dataRender = data.map((d, index) => ({ name: d.name, total: d.data.total, color: getColorStatus(index)  }));
	return <Box loading={false}>
		<div className="CardSummaryStage">
			{!isReady && <Loading />}
			{isReady && <div className="CardSummaryStage-Content">
				<div className="CardSummaryStage-Chart">
					<h2>Etapas de embarque del cobre</h2>
					<PieChart loading={!isReady} data={dataRender} />
				</div>
				<div className="CardSummaryStage-Info">
					<SummaryTitleItem titleItem="Etapa" />
					{dataRender.map(dr => <SummaryItem key={dr.name} data={dr}  />)}
				</div>
			</div>}
		</div>
	</Box>
}

export default CardSummaryStage;
